import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { TareaService } from '../../services/tarea.service';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'app-dlg-firma-conjunta-crear-tareas',
    imports: [
        MatDialogModule,
        MatButtonModule,
        ReactiveFormsModule, FormsModule,
        MatInputModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './dlg-firma-conjunta-crear-tareas.component.html',
    styleUrl: './dlg-firma-conjunta-crear-tareas.component.scss'
})
export class DlgFirmaConjuntaCrearTareasComponent {
  readonly data = inject<any>(MAT_DIALOG_DATA);

  fetchingFirmaConjuntaCrearNuevasTareas = false
  utilService: UtilService = inject(UtilService);

  constructor(
    public dialogRef: MatDialogRef<DlgFirmaConjuntaCrearTareasComponent>,
    private tareaService: TareaService,
    private toast: ToastService,
  ) { }

  firmaConjuntaCrearTareas() {
    this.fetchingFirmaConjuntaCrearNuevasTareas = true
    this.tareaService.firmaConjuntaCrearNuevasTareas(this.data.idTarea.toString(), this.data.idAnexo).subscribe({
      next: (_) => {
        const snackbarData: ScnackbarData = {
          message: "Nuevas tareas de firma conjunta creadas",
          style: SnackbarStyles.Success,
          iconName: "check_circle"
        }
        this.toast.show(snackbarData)
        this.fetchingFirmaConjuntaCrearNuevasTareas = false
        this.dialogRef.close(true)
        this.utilService.callTasks();
        
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 406) {
          const snackbarData: ScnackbarData = {
            message: error.error,
            style: SnackbarStyles.Warning,
          }
          this.toast.show(snackbarData)
        }else{
          const snackbarData: ScnackbarData = {
            message: "Error creando nuevas tareas de firma conjunta",
            style: SnackbarStyles.Error,
          }
          this.toast.show(snackbarData)
        }
        this.fetchingFirmaConjuntaCrearNuevasTareas = false
        this.dialogRef.close(true)
      }
    })
  }


  close() {
    this.dialogRef.close(true);
  }
}
